export default {"src":"/_next/static/media/checkmark-sm.8b815e39.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};